import { Component } from '@angular/core';
import { } from 'sha1'
import { Http } from "@angular/http";

declare var document: any;
declare var sha256: any
declare var $: any;
declare var jquery: any;
@Component({
    selector: 'home',
    template: require('./home.component.html')
}) 
export class HomeComponent {
    private currentPanel: string = 'document-selection-panel'//'document-selection-panel'//'plain-white-panel'
    private verified: boolean = false
    private currentMessage = "Initial State"
    private currentProgressPercentage = "99"
    constructor(private http: Http) {
        //setTimeout(x => {
        //    this.currentPanel ='document-selection-panel'
        //}, 1000) 
    }
    public getVerification() {
        $("#verify-result").html("");
        //function print(text: any) {
        //    $("#verify-result").html($("#verify-result").html()+"<br/>"+text)
        //}

        var print = (text: any) => {
            $("#verify-result").html($("#verify-result").html() + "<br/>" + text)
            this.currentMessage = text
        }


        this.currentPanel = 'progress-panel'
        print("Reading File...")
        var file = document.querySelector('input[type=file]').files[0];
        var reader = new FileReader();

        reader.addEventListener("load", () => { 
            this.currentPanel ='progress-panel'
            print("Calculating Hash...")
            var result = reader.result.split(',')[1]
            //console.log(result)
            var hash = sha256(result)
            print("SHA256 Result " + hash)
            setTimeout(x => {
                print("Verifying...")
                console.log(sha256(result))
                $.get('/api/enadocdocument?hash=' + hash, (r: any) => {
                    if (r.result) {
                        this.verified = true;
                        print("Verified!")
                    }
                    else {
                        this.verified = false;
                        print("Unknown Document!")
                    }
                    this.currentPanel = "completed-panel"
                    document.getElementById("file-selector").value = "";
                    //print("Done!")
                })
            },1000)
        }, false);

        if (file) {
            reader.readAsDataURL(file);
        }

     //   alert(sha1('hi'))
    }

    public browseClick() {
        $('input[type=file]').trigger('click');
    }

    public reInitProcess() {
        this.currentPanel ="document-selection-panel"
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/home/home.component.ts